<template>
  <div class="ly_modal_container" :style="{zIndex}">
    <div class="ly_modal_header" @mousedown="dragStart">
      <h1 class="title">소식톡톡 {{ getNewsTypeText(newsType) }} 수정</h1>
    </div>
    <div class="ly_modal_content" style="min-height: 472px; min-width: 837px">
      <div v-if="newsData" class="table_wrapper">
        <table class="table_view" style="width: 800px">
          <caption>
            <span class="blind">소식톡톡 {{ getNewsTypeText(newsType) }} 수정</span>
          </caption>
          <colgroup>
            <col width="120" />
            <col />
          </colgroup>
          <tbody class="table_view_body">
            <RepeatTypeViewer :newsType="newsType" :customNewsType="customNewsType" />
            <TargetViewer
              :rcpGroupSendYn="newsData.rcpGroupSendYn"
              :rcpDesc="newsData.rcpDesc"
              @clickRcpListView="onClickRcpListView"
              ref="targetSelector"
            />
            <!-- <TitleInput :boardTitle.sync="newsData.boardTitle" :required="true" ref="titleInput" /> -->
            <ContentInput
              :boardContent.sync="newsData.boardContent"
              :required="true"
              :useSample="true"
              :maxLength="300"
              ref="contentInput"
            />
            <RepeatStrategySelector
              :period.sync="newsData.repeatStrategy.period"
              :dayOfWeek.sync="newsData.repeatStrategy.dayOfWeek"
              ref="repeatStrategySelector"
            />
            <RepeatReserveTimeSelector :reserveTime.sync="newsData.reserveTime" ref="repeatReserveTimeSelector" messageType="updater" />
            <SnoozeSelector
              v-if="newsData.newsType === 'REPEAT'"
              messageType="updater"
              :hasSnooze.sync="newsData.hasSnooze"
              :snoozeMax.sync="newsData.snoozeMax"
              :snoozeInterval.sync="newsData.snoozeInterval"
              :intervalList="[0, 1, 2, 3, 4, 5, 6, 7]"
              ref="snoozeSelector"
            />
            <RepeatExperationDateSelector :from.sync="newsData.validFrom" :to.sync="newsData.validTo" ref="repeatExperationDateSelector" />
          </tbody>
        </table>

        <div class="btn_area">
          <button type="button" class="btn_active" @click="submit">수정</button>
          <button type="button" class="btn_default" @click="close">닫기</button>
        </div>
      </div>
    </div>

    <button type="button" @click.prevent="close" class="ly_modal_close">
      <span class="ico">팝업 닫기</span>
    </button>
  </div>
</template>

<script>
import popupMixin from '$mixins/popup';
import newsMixin from '$views/News/_mixin';
import newsRegisterMixin, {defaultData} from './mixins/register';

import TargetViewer from './inputs/TargetViewer';
import TitleInput from './inputs/TitleInput';
import ContentInput from './inputs/ContentInput';
import SnoozeSelector from './inputs/SnoozeSelector';

import RepeatTypeViewer from './inputs/RepeatTypeViewer';
import RepeatStrategySelector from './inputs/RepeatStrategySelector';
import RepeatReserveTimeSelector from './inputs/RepeatReserveTimeSelector';
import RepeatExperationDateSelector from './inputs/RepeatExperationDateSelector';

export default {
  mixins: [popupMixin, newsMixin, newsRegisterMixin],
  props: {
    newsId: [String, Number],
    newsType: String,
    customNewsType: String,
    onSubmit: Function,
  },
  components: {
    TargetViewer,
    TitleInput,
    ContentInput,
    SnoozeSelector,
    RepeatStrategySelector,
    RepeatReserveTimeSelector,
    RepeatExperationDateSelector,
    RepeatTypeViewer,
  },
  data() {
    return {
      selectedRcpList: [],
      newsData: null,
    };
  },
  computed: {
    apiUrl() {
      return this.newsData.newsType === 'REPEAT' ? '/admin/v2/news/repeat' : '/admin/v2/news/custom';
    },
  },
  methods: {
    submit() {
      if (!this.validate()) return false;
      const params = {
        newsType: this.newsData.newsType,
        customNewsType: this.newsData.customNewsType,
        boardTitle: this.newsData.boardTitle,
        boardContent: this.newsData.boardContent,
        rcpGroupSendYn: this.newsData.rcpGroupSendYn,
      };

      if (this.isReadyStatus) {
        params.pushType = this.newsData.pushType;
        if (params.pushType === 'RESERVE') {
          params.reserveDate = this.$utils.timeText(this.newsData.reserveDate, true);
        }
      }

      const {repeatStrategy, reserveTime, snoozeMax, snoozeInterval, validFrom, validTo, hasSnooze} = this.newsData;
      Object.assign(params, {
        repeatStrategy,
        reserveTime,
        snoozeMax,
        snoozeInterval,
        validFrom,
        validTo,
        hasSnooze,
      });

      const messages = this.newsData.newsType === 'CUSTOM' ? this.getSubmitMessagesCustom() : this.getSubmitMessagesRepeat();
      confirm(messages.confirm).then(() => {
        this.$axios.put(`${this.apiUrl}/${this.newsId}`, params).then(() => this.onSubmitData(messages.complete));
      });
    },
    onSubmitData(msg) {
      alert(msg);
      if (this.onSubmit) this.onSubmit();
      this.close();
    },
    validate() {
      return !(
        !this.$refs.contentInput.validate() ||
        !this.$refs.repeatStrategySelector.validate() ||
        (this.$refs.snoozeSelector && !this.$refs.snoozeSelector.validate())
      );
    },
    onClickRcpListView() {
      this.openRepeatRecipientList({newsId: this.newsId});
    },
  },
  mounted() {
    this.$axios.get(`/admin/v2/news/repeat/${this.newsId}/detail`).then(({data}) => {
      if (!data.data.repeatStrategy) data.data.repeatStrategy = defaultData.repeatStrategy; // 나중에 개선할것. null값이 오는경우가 있음
      this.newsData = _.merge({}, defaultData, data.data);
      this.$nextTick(this.moveToCenter);

      // 수정확인 메세지를 위해 rcp list 가져옴
      if (this.newsData.rcpGroupSendYn === 'N') {
        this.$axios(`/admin/happy/news/${this.newsId}/rcp/lists`).then(({data}) => (this.selectedRcpList = data.data));
      }
    });
  },
};
</script>
